import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loadingModal: false,
        errorPopup: false,
        errorPopupProps: {
            title: 'Σφάλμα!',
            text: 'error',
            color: 'indianRed',
            class: 'white--text indianRed text-center justify-center',
            icon: 'error',
            successStyle:false
        },
        simpleSearch: true,
        filesBaseUrl: true,
        filesThumbnailBaseUrl: true,
        loadingPublishers: true,
        publishersForSelector: [],
        instructionsDialog:false,
        bookInfoDialog:false,
        confirmModal:false,
        bookFileModal: false,
        confirmationDialog: false,
        confirmationDialogEventName: '',
        confirmationDialogText: '',
        reusableCalendarDialog: false,
        bookImagesDialog: false,

    },
    getters: {
        loadingModal: state => state.loadingModal,
        errorPopup: state => state.errorPopup,
        errorPopupProps: state => state.errorPopupProps,
        simpleSearch: state => state.simpleSearch,
        filesBaseUrl: state => state.filesBaseUrl,
        filesThumbnailBaseUrl: state => state.filesThumbnailBaseUrl,
        loadingPublishers: state => state.loadingPublishers,
        instructionsDialog: state => state.instructionsDialog,
        bookInfoDialog: state => state.bookInfoDialog,
        confirmModal: state => state.confirmModal,
        confirmationDialog: state => state.confirmationDialog,
        confirmationDialogEventName: state => state.confirmationDialogEventName,
        confirmationDialogText: state => state.confirmationDialogText,
        publishersForSelector: state => state.publishersForSelector,
    },
    mutations: {
        setLoadingModal: function (state, data) {
            state.loadingModal = data
        },
        setErrorPopup: function (state, data) {
            state.errorPopup = data
        },
        setErrorPopupProps: function (state, data) {
            state.errorPopupProps = data
        },
        setSimpleSearch: function (state, data) {
            state.simpleSearch = data
        },
        setFilesBaseUrl: function (state, data) {
            state.filesBaseUrl = data
        },
        setFilesThumbnailBaseUrl: function (state, data) {
            state.filesThumbnailBaseUrl = data
        },
        setLoadingPublishers: function (state, data) {
            state.loadingPublishers = data
        },
        setBookInfoDialog: function (state, data) {
            state.bookInfoDialog = data
        },
        setInstructionsDialog: function (state, data) {
            state.instructionsDialog = data
        },
        setBookFileModal: function (state, data) {
            state.bookFileModal = data
        },
        setBookImagesModal: function (state, data) {
            state.bookImagesModal = data
        },
        setConfirmModal: function (state, data) {
            state.confirmModal = data
        },
        setConfirmationDialog: function (state, data) {
            state.confirmationDialog = data
        },
        setConfirmationDialogEventName: function (state, data) {
            state.confirmationDialogEventName = data
        },
        setConfirmationDialogText: function (state, data) {
            state.confirmationDialogText = data
        },
        setPublishersForSelector: function (state, data) {
            state.publishersForSelector = data
        },
        setBooksForBooksTab: function (state, data) {
            state.booksForBooksTab = data
        },
    },
});
